export const REGIONS = {
  CANADA: 'canada',
  AUSTRALIA: 'australia'
} as const;

export type Region = (typeof REGIONS)[keyof typeof REGIONS];

export const getCurrentRegion = (): Region => {
  return window.location.hostname === 'scouterecruit.net' ? REGIONS.CANADA : REGIONS.AUSTRALIA;
};
